export const LEGAL_FORM = "LEGAL_FORM";
export const CONSTITUTIVE_LAW = "CONSTITUTIVE_LAW";

export const CATEGORIES = [
  LEGAL_FORM,
  CONSTITUTIVE_LAW,
];